import { render } from "./RoundLeaderboard.vue?vue&type=template&id=64c03fc3&scoped=true"
import script from "./RoundLeaderboard.vue?vue&type=script&lang=js"
export * from "./RoundLeaderboard.vue?vue&type=script&lang=js"

import "./RoundLeaderboard.vue?vue&type=style&index=0&id=64c03fc3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64c03fc3"]])

export default __exports__